// Podia → egyetem migration state for the login-page hint. One line to switch.
//
//   'podia'   – Kripto 3.0 is not published here yet: buyers are sent to Podia.
//   'partial' – published here with the video lessons only (the rest is
//               hidden until restored from Podia, see docs/kripto3-hianyzo-leckek.md):
//               automatic access here, the full material still on Podia.
//   'live'    – the full course is here: automatic access, nothing on Podia.
export const KRIPTO3_STATE = 'partial';

// The Kripto 3.0 course URL on Podia. null = not provided; the hint then says
// "a Podián" without a link instead of rendering a dead one.
export const PODIA_COURSE_URL = 'https://kriptovalutatanfolyam.podia.com/';

export const SUPPORT_EMAIL = 'hello@web3kurzus.hu';
